module.exports = __webpack_public_path__ + "static/media/safety-01.424a41a4.svg";